import React from 'react';
import { Link } from 'react-router-dom';

function CookiesPolicy() {
  return (
    <div className="main">
      {/* Header start */}
      <header id="header">
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-3 col-md-4 col-8 p-0">
              <div className="navbar-header" style={{paddingLeft: '0'}}>
                <Link className="navbar-brand" to="/">
                  <img alt="dptech" src="images/dptech_logo_white.png" style={{height: '60px'}} />
                </Link> 
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-4 p-0">
              <button data-target=".navbar-collapse" data-toggle="collapse" className="navbar-toggle d-block d-lg-none d-xl-none" type="button">
                <i className="fa fa-bars"></i>
              </button>
              <div className="overlay"></div>
              <div id="menu" className="navbar-collapse collapse">
                <ul className="nav navbar-nav">
                  <li className="level">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="level">
                    <Link to="/#data-solutions-part">Data solutions</Link>
                  </li>
                  <li className="level">
                    <Link to="/#cloud-part">Cloud</Link>
                  </li>
                  <li className="level">
                    <Link to="/#use-cases-part">Use case</Link>
                  </li>
                  <li className="level">
                    <Link to="/about">About</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Header end */}

      {/* Navbar Background Space */}
      <div style={{background: '#1a1a1a', height: '140px'}}></div>

      {/* Cookies Policy Content */}
      <section style={{padding: '30px 0 40px 0', background: '#fff'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="policy-content" style={{lineHeight: '1.8', color: '#333', textAlign: 'left'}}>
                
                {/* Page Title */}
                <div className="page-title" style={{textAlign: 'center', marginBottom: '50px'}}>
                  <h1 style={{color: '#1a1a1a', fontSize: '36px', fontWeight: '600', marginBottom: '15px', fontFamily: "'Poppins', sans-serif"}}>Cookies Policy</h1>
                  <div style={{width: '80px', height: '4px', background: 'linear-gradient(135deg, #FFD84D 0%, #FFA500 100%)', margin: '0 auto', borderRadius: '2px'}}></div>
                </div>
                
                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>1. Cosa sono i Cookie</h2>
                  <p style={{marginBottom: '15px'}}>
                    I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo (computer, tablet o smartphone) quando visiti un sito web. 
                    Questi file permettono al sito di "ricordare" le tue azioni e preferenze per un periodo di tempo limitato.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>2. Tipi di Cookie che Utilizziamo</h2>
                  
                  <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>2.1 Cookie Essenziali (Tecnici)</h3>
                  <p style={{marginBottom: '15px'}}>
                    Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati. Includono:
                  </p>
                  <ul style={{marginBottom: '20px', paddingLeft: '20px'}}>
                    <li style={{marginBottom: '8px'}}><strong>Cookie di sessione:</strong> Mantengono attiva la tua sessione durante la navigazione</li>
                    <li style={{marginBottom: '8px'}}><strong>Cookie di sicurezza:</strong> Proteggono il sito da attacchi e abusi</li>
                    <li style={{marginBottom: '8px'}}><strong>Cookie di preferenze:</strong> Memorizzano le tue scelte di consenso sui cookie</li>
                  </ul>

                  <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>2.2 Cookie Non Essenziali</h3>
                  <p style={{marginBottom: '15px'}}>
                    <strong>Attualmente non utilizziamo cookie di tracciamento, analytics o marketing.</strong> Se in futuro dovessimo implementare 
                    cookie non essenziali, ti chiederemo esplicitamente il consenso prima di attivarli.
                  </p>

                  <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>2.3 Servizi di Terze Parti</h3>
                  <p style={{marginBottom: '15px'}}>
                    Il nostro sito utilizza alcuni servizi esterni per funzionalità specifiche. Questi servizi potrebbero impostare 
                    cookie propri che non controlliamo direttamente:
                  </p>
                  
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <h4 style={{color: '#1a1a1a', fontSize: '18px', fontWeight: '600', marginBottom: '15px'}}>Servizi Utilizzati:</h4>
                    
                    <div style={{marginBottom: '15px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>FontAwesome (Icone)</h5>
                      <p style={{marginBottom: '0', fontSize: '14px', color: '#666'}}>
                        <strong>Scopo:</strong> Fornire icone per l'interfaccia utente<br/>
                        <strong>Cookie:</strong> Attualmente non impostiamo cookie per questo servizio<br/>
                        <strong>Dati raccolti:</strong> Nessun dato personale raccolto
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '15px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>Google Fonts (Tipografia)</h5>
                      <p style={{marginBottom: '0', fontSize: '14px', color: '#666'}}>
                        <strong>Scopo:</strong> Fornire il font Poppins per il sito<br/>
                        <strong>Cookie:</strong> Google potrebbe impostare cookie per il caricamento dei font<br/>
                        <strong>Dati raccolti:</strong> Google potrebbe raccogliere dati di utilizzo dei font
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '0'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>Formspree (Form di Contatto)</h5>
                      <p style={{marginBottom: '0', fontSize: '14px', color: '#666'}}>
                        <strong>Scopo:</strong> Gestire l'invio dei messaggi di contatto<br/>
                        <strong>Cookie:</strong> Formspree potrebbe impostare cookie per la gestione del form<br/>
                        <strong>Dati raccolti:</strong> Solo i dati che inserisci nel form (email, messaggio)
                      </p>
                    </div>
                  </div>
                  
                  <p style={{marginBottom: '0', marginTop: '15px', fontSize: '14px', color: '#666', fontStyle: 'italic'}}>
                    <strong>Nota:</strong> Per i servizi di terze parti, ti consigliamo di consultare le rispettive privacy policy 
                    per informazioni dettagliate sui cookie e sui dati raccolti. Questi servizi potrebbero implementare 
                    cookie aggiuntivi in futuro, nel qual caso ti informeremo e richiederemo il consenso appropriato.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>3. Lista Dettagliata dei Cookie Utilizzati</h2>
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <h4 style={{color: '#1a1a1a', fontSize: '18px', fontWeight: '600', marginBottom: '15px'}}>Cookie Essenziali (Sempre Attivi):</h4>
                    <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '14px'}}>
                      <thead>
                        <tr style={{borderBottom: '2px solid #FFD84D'}}>
                          <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #dee2e6'}}>Nome Cookie</th>
                          <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #dee2e6'}}>Scopo</th>
                          <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #dee2e6'}}>Durata</th>
                          <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #dee2e6'}}>Tipo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>cookieConsent</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Memorizza le tue preferenze sui cookie</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>12 mesi</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Essenziale</td>
                        </tr>
                        <tr>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>cookieConsentDate</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Data del consenso per validazione GDPR</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>12 mesi</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Essenziale</td>
                        </tr>
                        <tr>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>session_id</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Mantiene attiva la sessione di navigazione</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Sessione</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #dee2e6'}}>Essenziale</td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <h4 style={{color: '#1a1a1a', fontSize: '18px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>Cookie Non Essenziali (Attualmente Non Utilizzati):</h4>
                    <p style={{color: '#666', fontSize: '14px', fontStyle: 'italic'}}>
                      Non utilizziamo attualmente cookie di analytics, marketing o tracciamento. Se in futuro dovessimo implementarli, 
                      ti chiederemo esplicitamente il consenso e aggiorneremo questa lista.
                    </p>
                  </div>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>4. Base Giuridica per il Trattamento</h2>
                  <p style={{marginBottom: '15px'}}>
                    Il trattamento dei cookie essenziali si basa sul nostro legittimo interesse nel fornire un sito web funzionale e sicuro. 
                    Per i cookie non essenziali (se implementati in futuro), la base giuridica sarà il tuo consenso esplicito.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>5. Gestione dei Cookie</h2>
                  
                  <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>5.1 Banner di Consenso</h3>
                  <p style={{marginBottom: '15px'}}>
                    Quando visiti il nostro sito per la prima volta, ti mostreremo un banner che ti informa sull'utilizzo dei cookie 
                    e ti permette di:
                  </p>
                  <ul style={{marginBottom: '20px', paddingLeft: '20px'}}>
                    <li style={{marginBottom: '8px'}}><strong>Accettare solo i cookie essenziali</strong> (raccomandato)</li>
                    <li style={{marginBottom: '8px'}}><strong>Accettare tutti i cookie</strong> (se implementati in futuro)</li>
                    <li style={{marginBottom: '8px'}}><strong>Rifiutare i cookie non essenziali</strong></li>
                  </ul>

                  <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '15px', marginTop: '25px'}}>5.2 Modifica delle Preferenze</h3>
                  <p style={{marginBottom: '15px'}}>
                    Puoi modificare le tue preferenze sui cookie in qualsiasi momento. Per farlo, elimina i cookie dal tuo browser 
                    e ricarica la pagina. Il banner di consenso riapparirà e potrai fare nuove scelte.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>6. Durata dei Cookie</h2>
                  <p style={{marginBottom: '15px'}}>
                    <strong>Cookie di sessione:</strong> Vengono eliminati automaticamente quando chiudi il browser<br/>
                    <strong>Cookie di consenso:</strong> Rimangono attivi per 12 mesi o fino a quando non li modifichi
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>7. Trasferimenti Internazionali</h2>
                  <p style={{marginBottom: '15px'}}>
                    I dati raccolti tramite i cookie essenziali sono elaborati e memorizzati in Italia e nell'Unione Europea. 
                    Non trasferiamo dati personali al di fuori dell'UE/SEE.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>8. Abilitazione, Disabilitazione e Eliminazione dei Cookie</h2>
                  <p style={{marginBottom: '15px'}}>
                    Puoi utilizzare il tuo browser internet per eliminare automaticamente o manualmente i cookie. Puoi anche specificare 
                    che determinati cookie non possano essere posizionati. Un'altra opzione è modificare le impostazioni del tuo 
                    browser internet in modo da ricevere un messaggio ogni volta che viene posizionato un cookie. Per maggiori 
                    informazioni su queste opzioni, consulta le istruzioni nella sezione Guida del tuo browser.
                  </p>
                  
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <h4 style={{color: '#1a1a1a', fontSize: '18px', fontWeight: '600', marginBottom: '15px'}}>Istruzioni per Browser Popolari:</h4>
                    
                    <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '10px', marginTop: '20px'}}>Chrome:</h5>
                    <p style={{marginBottom: '15px', fontSize: '14px'}}>
                      Impostazioni → Privacy e sicurezza → Cookie e altri dati dei siti → Gestisci cookie e dati dei siti
                    </p>
                    
                    <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '10px', marginTop: '20px'}}>Firefox:</h5>
                    <p style={{marginBottom: '15px', fontSize: '14px'}}>
                      Opzioni → Privacy e sicurezza → Cookie e dati dei siti → Gestisci dati
                    </p>
                    
                    <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '10px', marginTop: '20px'}}>Safari:</h5>
                    <p style={{marginBottom: '15px', fontSize: '14px'}}>
                      Preferenze → Privacy → Gestisci dati dei siti web
                    </p>
                    
                    <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '10px', marginTop: '20px'}}>Edge:</h5>
                    <p style={{marginBottom: '15px', fontSize: '14px'}}>
                      Impostazioni → Cookie e autorizzazioni sito → Cookie e dati del sito
                    </p>
                  </div>
                  
                  <p style={{marginBottom: '15px', marginTop: '20px'}}>
                    <strong>Nota importante:</strong> Il nostro sito web potrebbe non funzionare correttamente se tutti i cookie sono disabilitati. 
                    Se elimini i cookie nel tuo browser, verranno posizionati di nuovo dopo il tuo consenso quando visiti nuovamente il nostro sito web.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>9. I Tuoi Diritti</h2>
                  <p style={{marginBottom: '15px'}}>
                    Ai sensi del GDPR, hai i seguenti diritti rispetto ai tuoi dati personali:
                  </p>
                  
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <h4 style={{color: '#1a1a1a', fontSize: '18px', fontWeight: '600', marginBottom: '15px'}}>Diritti GDPR sui Dati Personali:</h4>
                    
                    <div style={{marginBottom: '20px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>1. Diritto di Informazione</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Hai il diritto di sapere perché i tuoi dati personali sono necessari, cosa ne accadrà e per quanto tempo saranno conservati.
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '20px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>2. Diritto di Accesso</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Hai il diritto di accedere ai tuoi dati personali che sono a nostra conoscenza.
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '20px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>3. Diritto di Rettifica</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Hai il diritto di integrare, correggere, far cancellare o bloccare i tuoi dati personali ogni volta che lo desideri.
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '20px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>4. Diritto di Revoca del Consenso</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Se ci dai il tuo consenso per trattare i tuoi dati, hai il diritto di revocare quel consenso e di far cancellare i tuoi dati personali.
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '20px'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>5. Diritto di Trasferimento dei Dati</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Hai il diritto di richiedere tutti i tuoi dati personali dal titolare del trattamento e di trasferirli integralmente a un altro titolare.
                      </p>
                    </div>
                    
                    <div style={{marginBottom: '0'}}>
                      <h5 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '8px'}}>6. Diritto di Opposizione</h5>
                      <p style={{marginBottom: '0', fontSize: '14px'}}>
                        Puoi opporti al trattamento dei tuoi dati. Rispettiamo questo diritto, a meno che non ci siano motivi giustificati per il trattamento.
                      </p>
                    </div>
                  </div>
                  
                  <p style={{marginBottom: '15px', marginTop: '20px'}}>
                    Per esercitare questi diritti, contattaci. Fai riferimento ai dettagli di contatto in fondo a questa Cookie Policy. 
                    Se hai un reclamo su come gestiamo i tuoi dati, vorremmo sentire la tua opinione, ma hai anche il diritto di 
                    presentare un reclamo all'autorità di controllo (l'Autorità Garante per la Protezione dei Dati Personali).
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>10. Contatti</h2>
                  <p style={{marginBottom: '15px'}}>
                    Per qualsiasi domanda sui cookie o per esercitare i tuoi diritti, contattaci:
                  </p>
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <p style={{marginBottom: '8px'}}><strong>Email:</strong> info@dptech.io</p>
                  </div>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>11. Aggiornamenti della Policy</h2>
                  <p style={{marginBottom: '15px'}}>
                    Questa Cookie Policy può essere aggiornata periodicamente per riflettere cambiamenti nella nostra 
                    pratica sui cookie o per conformarci a nuove normative. Ti informeremo di eventuali modifiche 
                    significative attraverso il nostro sito web.
                  </p>
                  <p style={{marginBottom: '0'}}>
                    <strong>Ultimo aggiornamento:</strong> {new Date().toLocaleDateString('it-IT')}
                  </p>
                </div>

                  {/* Cookie Preference Editor */}
                  <div className="policy-section" style={{marginBottom: '40px'}}>
                    <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>12. Modifica le Tue Preferenze sui Cookie</h2>
                    <p style={{marginBottom: '20px'}}>
                      Puoi modificare le tue preferenze sui cookie in qualsiasi momento utilizzando il pannello qui sotto. 
                      Le modifiche si applicheranno immediatamente e verranno salvate per le tue future visite.
                    </p>
                    
                    <div style={{background: '#f8f9fa', padding: '30px', borderRadius: '8px', border: '1px solid #e9ecef'}}>
                      <h3 style={{color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '20px', textAlign: 'center'}}>🍪 Gestione Preferenze Cookie</h3>
                      
                      <div style={{background: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '4px', padding: '15px', marginBottom: '20px'}}>
                        <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
                          <strong>Nota:</strong> Attualmente utilizziamo solo cookie essenziali per il funzionamento del sito. 
                          Entrambe le opzioni qui sotto forniscono la stessa esperienza utente. Le differenze diventeranno 
                          rilevanti quando implementeremo cookie non essenziali in futuro.
                        </p>
                      </div>
                      
                      <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '20px'}}>
                        <button
                          onClick={() => {
                            localStorage.setItem('cookieConsent', 'essential');
                            localStorage.setItem('cookieConsentDate', new Date().toISOString());
                            alert('Preferenze aggiornate: Cookie essenziali abilitati');
                            window.location.reload();
                          }}
                          style={{
                            padding: '12px 24px',
                            background: '#FFD84D',
                            color: '#000',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => e.target.style.background = '#FFA500'}
                          onMouseOut={(e) => e.target.style.background = '#FFD84D'}
                          title="Abilita i cookie essenziali per il funzionamento del sito (raccomandato)"
                        >
                          Cookie Essenziali
                        </button>
                        
                        <button
                          onClick={() => {
                            localStorage.setItem('cookieConsent', 'all');
                            localStorage.setItem('cookieConsentDate', new Date().toISOString());
                            alert('Preferenze aggiornate: Tutti i cookie abilitati');
                            window.location.reload();
                          }}
                          style={{
                            padding: '12px 24px',
                            background: '#1a1a1a',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => e.target.style.background = '#333'}
                          onMouseOut={(e) => e.target.style.background = '#1a1a1a'}
                          title="Abilita tutti i tipi di cookie (per future implementazioni)"
                        >
                          Tutti i Cookie
                        </button>
                      </div>
                      
                      <div style={{textAlign: 'center'}}>
                        <button
                          onClick={() => {
                            localStorage.removeItem('cookieConsent');
                            localStorage.removeItem('cookieConsentDate');
                            alert('Preferenze cookie cancellate. Il banner riapparirà alla prossima visita.');
                            window.location.reload();
                          }}
                          style={{
                            padding: '8px 16px',
                            background: 'transparent',
                            color: '#999',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = '#f0f0f0';
                            e.target.style.color = '#666';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = 'transparent';
                            e.target.style.color = '#999';
                          }}
                        >
                          Cancella Preferenze
                        </button>
                      </div>
                      
                      <div style={{marginTop: '20px', padding: '15px', background: '#fff', borderRadius: '4px', border: '1px solid #e9ecef'}}>
                        <h4 style={{color: '#1a1a1a', fontSize: '16px', fontWeight: '600', marginBottom: '10px'}}>Stato Attuale:</h4>
                        <p style={{marginBottom: '0', fontSize: '14px', color: '#666'}}>
                          <strong>Consenso:</strong> {localStorage.getItem('cookieConsent') || 'Non impostato'} | 
                          <strong>Data:</strong> {localStorage.getItem('cookieConsentDate') ? new Date(localStorage.getItem('cookieConsentDate')).toLocaleDateString('it-IT') : 'Non impostata'}
                        </p>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer section start */}
      <footer style={{background: '#f8f9fa', color: '#555', padding: '60px 0 20px 0', marginTop: 0}}>
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <img src="images/dpTech_logo_1916x710_300dpi_RGB_transparent.png" alt="dpTech" style={{height: '40px', marginBottom: '15px'}} />
                <p style={{color: '#555', lineHeight: '1.5', marginBottom: '15px', fontSize: '14px'}}>
                  dpTech è il tuo partner per l'innovazione. Trasformiamo i dati in valore per il tuo business.
                </p>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Servizi</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#data-solutions-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Data Solutions</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#cloud-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cloud</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#use-cases-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Use Cases</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Chi Siamo</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Legal & Contact */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Informazioni</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/privacy" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Privacy Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/cookies" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cookies Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Contattaci</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Contact Info */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Contatti</h5>
                <div style={{color: '#555', lineHeight: '1.5'}}>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-envelope" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    info@dptech.io
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-map-marker-alt" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    Milano, Italia
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <a href="https://www.linkedin.com/company/dptech-io" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease'}}>
                      <i className="fab fa-linkedin" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                      LinkedIn
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Footer Bottom */}
          <div className="footer-bottom" style={{borderTop: '1px solid #dee2e6', paddingTop: '20px', marginTop: '20px'}}>
            <div className="row align-items-center">
              <div className="col-6 text-left">
                <p style={{color: '#555', margin: 0, fontSize: '13px', lineHeight: '1.4'}}>
                  © 2025 dpTech | Data Solutions. Tutti i diritti riservati.<br />
                  P.IVA: 14159740969
                </p>
              </div>
              <div className="col-6 text-right">
                <div style={{color: '#555', fontSize: '11px', lineHeight: '1.3'}}>
                  <p style={{margin: 0, fontStyle: 'italic', fontFamily: "'Poppins', sans-serif"}}>
                    dptech.io si impegna a seguire le linee guida WCAG 2.1 AA, e a rendere il proprio sito web accessibile.{' '}
                    <a href="/files/Dichiarazione di accessibilita.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'underline'}}>Dichiarazione di accessibilità</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Footer section end */}
    </div>
  );
}

export default CookiesPolicy;
